export const actions = {
  search: 'REQUEST_SEARCH',
  moreEpisodes: 'REQUEST_MORE_EPISODES_SEARCH',
  details: 'REQUEST_MORE_DETAILS_SEARCH',
};

export const requestSearch = (q, nid) => ({
  type: actions.search,
  query: q,
  nid: nid,
});

export const requestProgramMoreEpisodes = (progType, nid, id, pid) => ({
  type: actions.moreEpisodes,
  progType,
  nid,
  id,
  pid,
});

export const requestProgramDetails = (progType, id, pid) => ({
  type: actions.details,
  progType,
  id: id,
  pid: pid,
});
